<script>
import VueApexCharts from 'vue-apexcharts'
import {Russian} from 'flatpickr/dist/l10n/ru.js'
import Multiselect from 'vue-multiselect'
import moment from "moment";

export default {
  components: {VueApexCharts, Multiselect},
  data() {
    return {
      dateConfig: {
        mode: 'range',
        locale: Russian,
        dateFormat: 'd.m.Y',
      },

      form: {
        dateRange: null,
        status: null,
        duration: null,
        taskTarget: null,
        search: null,
        groupContacts: null
      },

      statusOptions: [
        { id: 'active', name: 'Активна' },
        { id: 'paused', name: 'Отложена' },
        { id: 'success', name: 'Выполнена' },
        { id: 'canceled', name: 'Отменена' },
        { id: 'archive', name: 'В архиве' },
      ],
      groupsContactsList: [],
      taskTargetOptions:[{id: 'call', name: 'Позвонить'}],


      series: [44, 55, 13, 43, 22],
      chartOptions: {
        chart: {
          width: 380,
          type: 'pie'
        },
        labels: ['A', "A", "A", "A", "A"],
        responsive: [{
          breakpoints: 480,
          options: {
            chart: {
              width: 200
            },
            length: {
              position: 'bottom'
            }
          }
        }]
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('contactsCategories/FETCH_CONTACTS_CATEGORIES_LIST', {});
    this.groupsContactsList = this.$store.getters['contactsCategories/GET_CONTACTS_CATEGORIES_LIST_DATA'];

    const dateStart = moment().format('DD.MM.YYYY').toString()
    const dateEnd = moment().subtract(1, 'w').format('DD.MM.YYYY').toString()
    this.form.dateRange = `${dateStart} — ${dateEnd}`

    this.form.status = { id: 'success', name: 'Выполнена' }
    this.form.duration = 10

  },
}
</script>

<template>
  <div class="row">
    <div class="col-6">
      <div id="chart">
        <VueApexCharts type="pie" width="380" :options="chartOptions" :series="series" />
      </div>
    </div>
    <div class="col-6">
      <b-form>
        <div class="row">
          <div class="col">
            <b-form-group label="Поиск" label-for="search">
              <b-form-input id="search" v-model="form.search" placeholder="Введите текст..."/>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <b-form-group label="Период" label-for="date-range">
              <flat-pickr
                  v-model="form.dateRange"
                  class="form-control"
                  :config="dateConfig"
              />
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Статус" label-for="status">
              <Multiselect
                  id="status"
                  v-model="form.status"
                  track-by='id'
                  label="name"
                  :options="statusOptions"
                  placeholder="Статус"
                  select-label=""
                  deselect-label="Сброс"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <b-form-group label="Длительность (сек)" label-for="duration">
              <b-form-input id="duration" v-model="form.duration" type="number" placeholder="Минимальное время (сек)"/>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Задача" label-for="task-target">
              <Multiselect
                  id="task-target"
                  v-model="form.taskTarget"
                  track-by='id'
                  label="name"
                  :options="taskTargetOptions"
                  placeholder="Задача"
                  select-label=""
                  deselect-label="Сброс"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b-form-group label="Группа контактов" label-for="task-target">
              <Multiselect
                  id="task-target"
                  v-model="form.groupContacts"
                  track-by='id'
                  label="name"
                  :options="groupsContactsList"
                  placeholder="Выберите группу контактов"
                  select-label=""
                  deselect-label="Сброс"
              />
            </b-form-group>
          </div>
        </div>
      </b-form>
    </div>
  </div>

</template>

<style scoped>

</style>